export const GENERATE_STATUS = {
  YES: 1,
  NO: 2,
  IN_PROGRESS: 3,
};
